import axiosInstance from "shared/axios";
import { AUTO_DISBURSEMENT_API } from "shared/constants";

export const autoDisbursementListing = (data) => {
  let url =  `${AUTO_DISBURSEMENT_API.listing}`;
  return axiosInstance.post(url,data);
};

export const autoDisbursementDropDown = () =>{
  let url = `${AUTO_DISBURSEMENT_API.dropDown}`
  return axiosInstance.get(url)
}

export const autoDisbursementSettlement = (data) =>{
  let url = `${AUTO_DISBURSEMENT_API.settlementDetail}`
  return axiosInstance.post(url,data)
}

export const autoDisbursementDisbursement = (data) =>{
  let url = `${AUTO_DISBURSEMENT_API.disbursementDetail}`
  return axiosInstance.post(url,data)
}
export const retryDisburse = (data) =>{
  let url = `${AUTO_DISBURSEMENT_API.retryDisburse}`
  return axiosInstance.post(url,data)
}

export const autoDisTotalCount = (data) => {
  let url = `${AUTO_DISBURSEMENT_API.listing}`
  return axiosInstance.post(url,data)
}